import { Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-spin',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-spin.component.html',
  styleUrl: './custom-spin.component.scss'
})
export class CustomSpinComponent {
  @Input() spinning: boolean = true;
  @Input() tip: string = '';
  @Input() indicator?: TemplateRef<void>;
  @Input() size: 'default' | 'small' = 'default';
  // Overrides the container's default min-height (200px) for callers wrapping content shorter
  // than that, e.g. small thumbnails — the default is sized for the full-size spin icon.
  @Input() minHeight?: string;
  // Makes the container a flex column that stretches to fill its parent's available height
  // instead of sizing to just its content, so the loader centers in the real available space
  // regardless of how much content ends up there. Content is never clipped: it can still grow
  // taller than the available space and the box grows with it (see scrollableContent below for
  // the opposite case).
  @Input() fillHeight = false;
  // Combine with fillHeight for callers wrapping a widget that manages its own internal
  // scrolling (e.g. a virtual-scroll table with a fixed height) — lets the box shrink below the
  // widget's full-data height instead of growing to fit every row, so the widget's own scrollbar
  // takes over. Leave off for naturally-flowing content (forms, plain tables) that should never
  // be clipped.
  @Input() scrollableContent = false;
  // Makes the overlay fully solid instead of the default translucent blur — for callers where
  // the content underneath shouldn't show through at all while loading (e.g. a form mid-edit).
  @Input() opaque = false;

  @HostBinding('class.custom-spin-fill')
  get hostFill(): boolean {
    return this.fillHeight;
  }

  @HostBinding('class.custom-spin-active')
  get hostActive(): boolean {
    return this.spinning;
  }

  @HostBinding('class.custom-spin-scrollable')
  get hostScrollable(): boolean {
    return this.fillHeight && this.scrollableContent;
  }
}
